import React, {useMemo} from "react"
import SideMenu from "../sideMenu"
import {
  CandleChart,
  TrendDialog,
  RankingDialog,
} from "../components"

export default function ChartPage() {
  return useMemo(
    () => (
      <>
        <TrendDialog />
        <RankingDialog />
        <SideMenu />
        <CandleChart id={`targetChart`} />
      </>
    ),
    [],
  )
}
